import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';

const propTypes = {
  activeStep: PropTypes.number.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export function UnstyledRocketProgress({ activeStep, classes }) {
  const rocketImageSrc = [
    '/images/rockets/rocket-step1.svg',
    '/images/rockets/rocket-step2.svg',
    '/images/rockets/rocket-step3.svg',
  ];
  const rocketImageClasses = (thisStep) => {
    switch (thisStep) {
      case 1:
        return classnames(classes.rocketImage, classes.rocketProgressStepTwo);
      case 2:
        return classnames(classes.rocketImage, classes.rocketProgressStepThree);
      default:
        return classes.rocketImage;
    }
  };
  return (
    <React.Fragment>
      <img
        src={rocketImageSrc[activeStep]}
        className={rocketImageClasses(activeStep)}
        alt="Rocket"
      />
      <hr className={classes.rocketLine} />
    </React.Fragment>
  );
}

UnstyledRocketProgress.propTypes = propTypes;

const styles = (theme) => ({
  rocketLine: {
    width: `calc(100% + ${theme.spacing(2)}px)`,
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
    border: 'unset',
    height: 1,
    backgroundColor: theme.customColors.lightGrey,
    top: theme.spacing(-4.6),
    position: 'relative',
    zIndex: 1,

    [theme.breakpoints.down('sm')]: {
      width: `calc(100% + ${theme.spacing(2)}px)`,
      marginLeft: theme.spacing(-1),
      top: theme.spacing(-2.5),
    },
  },
  rocketImage: {
    height: theme.spacing(4),
    transition: 'all 500ms ease-in-out',
    position: 'relative',
    zIndex: 2,
    top: theme.spacing(-1.75),

    [theme.breakpoints.down('sm')]: {
      top: '3px',
    },
  },
  rocketProgressStepTwo: {
    paddingLeft: '27.5%',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '40%',
    },
  },
  rocketProgressStepThree: {
    paddingLeft: '46%',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 'calc(100% - 209px)',
    },
  },
});

export default withStyles(styles)(UnstyledRocketProgress);
